import React, { useEffect, useState } from "react";
import Reportselect from "./Reportselect";
import { gettravelhistory } from "../../services/Reportservice";
import Select from "react-select";
import { format, parse } from "date-fns";
import { Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { searchroute } from "../../services/Reportservice";
import { PiExportBold } from "react-icons/pi";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import { getbusarrivaldetails } from "../../services/Reportservice";
import { getBusArrivalStatus } from "../../utilities";
import { FaMapMarkerAlt } from "react-icons/fa";
import { convertToAMPM } from "../../utilities";
import { getBusListSearchApi } from "../../services/SearchService";
import Pagination from "../Constant/Pagination";
import { gettravelhistortyexport } from "../../services/Reportservice";
import {
  addDays,
  subDays,
  startOfMonth,
  endOfMonth,
  subMonths,
} from "date-fns";
import Stopreport from "./livereport/Stopreport";
import Employeereport from "./livereport/Employeereport";
import { Offcanvas } from "react-bootstrap";
import { useWindowWidth } from "../../utilities";
// import 'react-datepicker/style.css';
const formatTo12Hour = (timeStr) => {
  const parsedTime = parse(timeStr, "HH:mm", new Date());
  return format(parsedTime, "hh:mm a");
};
const Travelhistory = () => {
  const [tripoption, setTripoption] = useState([
    { label: "Pickup", value: "PICKUP" },
    { label: "Drop", value: "DROP" },
  ]);
  const width = useWindowWidth();
  const [showDatePicker, setShowDatePicker] = useState(false);
  const defaultOption = { value: "7_days", label: "Last 7 Days" };
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const [loading, setLoading] = useState(false);
  const [excellLoading, setExcellLoading] = useState(false);
  const [data, setData] = useState([]);
  const [routeoption, setRouteoption] = useState([]);
  const [shiftoption, setShiftoption] = useState([]);
  const [showSidebar, setShowSidebar] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tabType, setTabtype] = useState("");
  const [busoption, setBusoption] = useState([]);
  const [selectedbus, setSelectedbus] = useState(null);
  const [selecetdroute, setSelectedroute] = useState(null);
  const [selectedtrip, setSelectedtrip] = useState(null);
  const [total, setTotal] = useState(0);
  const handlesidebar = () => {
    if (showSidebar) {
      setTabtype("");
    } else {
      setTabtype("stop");
    }
    setShowSidebar(!showSidebar);
  };
  const [param, setParam] = useState({
    start_date: format(subDays(new Date(), 7), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
    bus_id: "",
    trip_mode: "",
    route_id: "",
    page: "1",
    page_size: "10",
  });
  const options = [
    { value: "yesterday", label: "Yesterday" },
    { value: "7_days", label: "Last 7 Days" },
    { value: "15_days", label: "Last 15 Days" },
    { value: "30_days", label: "Last 30 Days" },
    { value: "last_month", label: "Last Month" },
    { value: "3_months", label: "Last 3 Months" },
    { value: "custom", label: "Custom Date" },
  ];
  useEffect(() => {
    getBusListSearchApi()
      .then((res) => {
        setBusoption(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    searchroute()
      .then((res) => {
        setRouteoption(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const getreport = () => {
    setLoading(true);
    gettravelhistory(param)
      .then((res) => {
        setData(res.data?.data || []);
        setTotal(res.data?.count || 0);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getreport();
  }, [param]);
  useEffect(() => {
    setParam({
      ...param,
      trip_type: selectedtrip?.value || "",
      route_id: selecetdroute?.value || "",
      bus_id: selectedbus?.value || "",
      page: "1",
    });
  }, [selectedbus, selectedtrip, selecetdroute]);

  const handleSelectChange = (option) => {
    setSelectedOption(option);
    if (!option) {
      setParam({ ...param, start_date: "", end_date: "", page: "1" });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "yesterday":
        startDate = subDays(new Date(), 1);
        endDate = startDate;
        break;
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
      page: "1",
    });
  };

  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleexport = () => {
    setExcellLoading(true);
    const newparam = { ...param, export: true };
    gettravelhistortyexport(newparam)
      .then((res) => {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "travelhistory-report.xlsx"; // set your desired filename
        a.click();

        window.URL.revokeObjectURL(url); // clean up
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setExcellLoading(false);
      });
  };
  const tabs = {
    stop: <Stopreport rowData={selectedRow} />,
    employee: <Employeereport rowData={selectedRow} />,
  };
  return (
    <>
      <div className="row mb-3">
        <div className="col d-flex flex-column flex-md-row justify-content-between">
          <div>
            <span
              className="text-primary"
              style={{ fontSize: "1.3rem", fontWeight: "500" }}
            >
              Travel History
            </span>
            <ol className="breadcrumb breadcrumb-arrow mb-0">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Report
              </li>
            </ol>
          </div>
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <div style={{ width: "300px" }}>
              <Reportselect />
            </div>
            <button
              className="btn btn-primary d-flex align-items-center gap-1 align-self-center"
              onClick={handleexport}
              // style={{ height: "38px" }}
              disabled={excellLoading || data.length === 0}
            >
              {" "}
              {excellLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <PiExportBold size={18} />
              )}
              Export
            </button>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="d-flex justify-content-between flex-column flex-md-row gap-2 px-4 py-3">
          <div className="d-flex flex-column flex-md-row gap-3">
            <div className="flex-fill flex-md-grow-0 w-md-auto">
              <small>Select Bus</small>
              <Select
                className="react-select"
                classNamePrefix="select"
                options={busoption}
                value={selectedbus}
                onChange={setSelectedbus}
                isClearable
                placeholder="Select Bus"
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 999,
                  }),
                }}
              />
            </div>
            <div className="flex-fill flex-md-grow-0 w-md-auto">
              <small>Select Route</small>
              <Select
                className="react-select"
                classNamePrefix="select"
                options={routeoption}
                value={selecetdroute}
                onChange={setSelectedroute}
                isClearable
                placeholder="Select Route"
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 999,
                  }),
                }}
              />
            </div>
            <div className="flex-fill flex-md-grow-0">
              <small>Select Trip</small>
              <Select
                className="react-select"
                classNamePrefix="select"
                options={tripoption}
                value={selectedtrip}
                onChange={setSelectedtrip}
                placeholder="Select Trip"
                isClearable
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 999,
                  }),
                }}
              />
            </div>
          </div>
          <div className="d-flex flex-column flex-md-row gap-2">
            {showDatePicker && (
              <div className="flex-fill flex-md-grow-0">
                <small>Select Date</small>
                <DatePicker
                  selectsRange
                  startDate={
                    param?.start_date ? new Date(param.start_date) : null
                  }
                  endDate={param?.end_date ? new Date(param.end_date) : null}
                  onChange={(update) => {
                    const [start, end] = update;
                    setParam((prev) => ({
                      ...prev,
                      start_date: start ? format(start, "yyyy-MM-dd") : "",
                      end_date: end ? format(end, "yyyy-MM-dd") : "",
                      page: 1,
                    }));
                  }}
                  isClearable
                  placeholderText="Select date range"
                  className="form-control"
                  style={{
                    fontSize: "0.5rem",
                  }}
                  popperProps={{
                    modifiers: [
                      {
                        name: "zIndex",
                        enabled: true,
                        phase: "beforeWrite",
                        fn({ state }) {
                          state.styles.popper.zIndex = 999;
                        },
                      },
                    ],
                  }}
                />
              </div>
            )}
            <div className="flex-fill flex-md-grow-0">
              <small>Select Period</small>
              <Select
                options={options}
                onChange={handleSelectChange}
                placeholder="Select Period"
                className="react-select"
                classNamePrefix="select"
                value={selectedOption}
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 999,
                  }),
                }}
              />
            </div>
          </div>
        </div>
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : data.length === 0 ? (
            <div className="p-2 text-center">There are no records found.</div>
          ) : (
            <div className="table-responsive">
              <table className="table align-middle fs-6 mb-0">
                <thead className="custom-thead table-light">
                  <tr>
                    <th>Date</th>
                    <th>Bus No.</th>
                    <th>Driver</th>
                    <th>Route</th>
                    <th>Shift</th>
                    <th>Schedule</th>
                    <th>Actual</th>
                    <th>Trip Mode</th>

                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, index) => {
                    const schedule_time = row?.stop_schedule_time
                      ? convertToAMPM(row.stop_schedule_time)
                      : "-";
                    const actual_time = row?.actual_time
                      ? convertToAMPM(row.actual_time)
                      : "-";
                    const stop = row?.destination_stop?.name || "N/A";
                    const tripType = row?.trip_mode || "";
                    const badgeClass =
                      tripType.toLowerCase() === "pickup"
                        ? "bg-info"
                        : "bg-secondary";
                    const { className: statusClass, text: statusText } =
                      getBusArrivalStatus(row?.status);

                    return (
                      <tr
                        key={index}
                        onClick={() => {
                          setSelectedRow(row);
                          handlesidebar();
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <td>
                          {row?.created_at
                            ? format(row?.created_at, "dd MMM yyy")
                            : "N/A"}
                        </td>
                        <td className="fw-semibold text-primary cursor-pointer">
                          {row?.bus?.number_plate || "N/A"}
                        </td>
                        <td className="fw-semibold text-primary cursor-pointer">
                          {row.driver?.name || "N/A"}
                        </td>
                        <td>{row?.route?.route_number || "N/A"}</td>
                        <td>{row?.shift?.name || "N/A"}</td>
                        <td>
                          <div style={{ lineHeight: 1.2 }}>
                            <div
                              className="fw-semibold"
                              style={{ fontSize: "14px" }}
                            >
                              {stop}
                            </div>
                            <div
                              style={{
                                color: "#666",
                                fontSize: "12px",
                                marginTop: "2px",
                              }}
                            >
                              {schedule_time}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div style={{ lineHeight: 1.2 }}>
                            <div
                              className="fw-semibold"
                              style={{ fontSize: "14px" }}
                            >
                              {stop}
                            </div>
                            <div
                              style={{
                                color: "#666",
                                fontSize: "12px",
                                marginTop: "2px",
                              }}
                            >
                              {actual_time}
                            </div>
                          </div>
                        </td>
                        <td>
                          <span className={`badge ${badgeClass} text-white`}>
                            {tripType.toUpperCase()}
                          </span>
                        </td>

                        <td>
                          <span className={statusClass}>{statusText}</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {!loading && data?.length > 0 && (
            <div className="border-top p-4">
              <Pagination
                currentPage={param.page}
                recordsPage={param.page_size}
                dataLength={total}
                handlePagination={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
      <Offcanvas
        show={showSidebar}
        onHide={handlesidebar}
        placement="end"
        style={{
          width:
            tabType === "employee"
              ? width < 992
                ? "80vw"
                : "400px"
              : width < 992
              ? "80vw"
              : "400px",
        }}
      >
        <Offcanvas.Header className="py-1 ps-2 pe-4" closeButton>
          <div>
            <ul className="nav flex-row custom-sidebar-nav px-2">
              <li
                className="nav-item cursor-pointer"
                onClick={() => setTabtype("stop")}
              >
                <span
                  className={`nav-link ${tabType == "stop" ? "active" : ""}`}
                >
                  Trip log
                </span>
              </li>
              <li
                className="nav-item cursor-pointer"
                onClick={() => setTabtype("employee")}
              >
                <span
                  className={`nav-link ${
                    tabType == "employee" ? "active" : ""
                  }`}
                >
                  Boarding log
                </span>
              </li>
            </ul>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-2" key={tabType}>
          {tabs[tabType]}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Travelhistory;
